module.exports = __webpack_public_path__ + "static/media/7.43d58178.jpg";